export const CHECK_EMAIL_API = "/api/Auth/check-email";
export const LOGIN_USER_API = "/api/Auth/login";
export const LOGIN_ANONYMOUS_API = "/api/Auth/AnonymousUser-OTP?userEmail="
export const DOOR_INSPECTION_API = "/api/Report/DownloadPropertyInspectionPDF";
export const GET_CLINET_ID_API = "/api/MasterData/GetClientUserRoleMapping";
export const PROPERTY_DASHBOARD_API =
  "/api/GetInspectionData/summary-by-clientId?";
export const GET_PROPERTY_INFO_WITH_MASTER =
  "/api/Inspection/GetInspectionMasterData/";
export const GENERATEQRCODE_API = "api/QrCode?text=";
export const SAVE_SURVEY_FORM_DATA = "/api/Inspection/inspection/submit-anonymous";
export const UPLOAD_IMAGE_API = "api/Inspection/upload";
export const DELETE_IMAGE_API = "/api/Inspection/delete-blob-url?blobUrl=";
export const GET_INSPECTION_PROPERTY_INFO_BYID =
  "/api/Inspection/GetInspectionPropertyInfoById/";
export const CREATE_INSPECTION_PROPERTY_APPROVAL_HISTORY =
  "/api/Inspection/CreateInspectionPropertyApprovalHistory";
export const GET_PROPERTY_USER_MAPPING =
  "/api/Inspection/GetPropertyUserMapping/";
export const GET_NEXT_REF_NUMBER = "/api/Inspection/GetNextRefNumber/";
export const UPDATE_PROPERTY_USER_MAPPING_STATUS =
  "/api/Inspection/UpdateStatusOfPropertyUserMapping/";
export const GET_PROPERTY_COMPLIANCE_SUMMARY =
  "/api/GetInspectionData/GetPropertyComplianceSummary";
export const GET_DOOR_INSPECTION_DATA = 
  "/api/GetInspectionData/GetFullInspectionByDoorRef?doorRef=";
export const UPDATE_PROPERTY_IMAGE = 
  "/api/GetInspectionData/UpdatePropertyImage";
export const GET_FLOORPLAN_IMAGE = 
  "/api/GetInspectionData/GetFLoorPlanByFloorNo?";
export const GET_SURVEY_BOOKINGS ="/api/SurveyBooking/get-bookings-by-user?email=";
export const GET_DOOR_TYPES = "/api/Inspection/GetAllDoorTypes";
export const GET_ANONYMOUS_INSPECTION_DATA = "/api/GetInspectionData/inspection/anonymousByUserEmail?email=";
export const GET_SURVEY_BOOKINGS_BY_EMAIL = "/api/SurveyBooking/GetBookingsByEmailOrAltEmailAsync?email=";
export const CANCEL_SURVEY_BOOKING = "/api/SurveyBooking/CancelSurveyBooking";
export const GET_USER_BY_EMAIL_OR_PHONE = "/api/RMS/GetUserByEmailOrPhoneAsync?email=";
export const BOOKINGS_API_URL ="/api/SurveyBooking";
export const AVAILABLE_SLOTS ="/api/SurveyBooking/available-slots?";
export const GET_RMS_USER_CONTACT_COUNT ="/api/RMS/GetRMSUserContactCount";
export const TRIGGER_EMAIL_TO_RESIDENT_USERS ="/api/RMS/TriggerEmailtoResidentUsers";
export const GET_RMS_USER_INFO_LIST ="/api/RMS/GetRMSUserInfoList";
